import { Body02 } from 'Components/designSystem';
import React, { memo } from 'react';
import styled from 'styled-components';

interface IconRowProps {
    className?: string;
    icon: React.ReactNode;
    content?: string;
}

function IconRow({ className, content, icon }: IconRowProps) {
    if (!content?.trim()) {
        return null;
    }

    return (
        <Root className={ className }>
            <IconContainer>
                { icon }
            </IconContainer>
            <Body02>
                { content }
            </Body02>
        </Root>
    );
}

const Root = styled.div`
    display: flex;
    gap: ${ ({ theme }) => theme.size.size_10 };
    flex-wrap: nowrap;
    align-items: flex-start;
`;

const IconContainer = styled.div`
    margin-top: ${ ({ theme }) => theme.size.size_2 };
    width: ${ ({ theme }) => theme.size.size_20 };
    height: ${ ({ theme }) => theme.size.size_20 };

    & svg {
        width: 100%;
        height: 100%;
    }
`;

export default memo(IconRow);
